import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Img = styled('img')``;

export const NotFoundContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(10, 10.5),
  height: 500,
  width: 500,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));
